import { render, staticRenderFns } from "./UniDate.vue?vue&type=template&id=71f40fce&scoped=true&"
import script from "./UniDate.vue?vue&type=script&lang=js&"
export * from "./UniDate.vue?vue&type=script&lang=js&"
import style0 from "./UniDate.vue?vue&type=style&index=0&id=71f40fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f40fce",
  null
  
)

export default component.exports